"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsteroidStandardProject = void 0;
const CardName_1 = require("../../../CardName");
const CardRenderer_1 = require("../../render/CardRenderer");
const constants_1 = require("../../../constants");
const StandardProjectCard_1 = require("../../StandardProjectCard");
const PartyHooks_1 = require("../../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../../turmoil/parties/PartyName");
const RedsPolicy_1 = require("../../../turmoil/RedsPolicy");
const Card_1 = require("../../Card");
const Units_1 = require("../../../Units");
const StandardProjectType_1 = require("../../../StandardProjectType");
class AsteroidStandardProject extends StandardProjectCard_1.StandardProjectCard {
    constructor() {
        super({
            name: CardName_1.CardName.ASTEROID_STANDARD_PROJECT,
            cost: 14,
            tr: { temperature: 1 },
            metadata: {
                cardNumber: 'SP9',
                renderData: CardRenderer_1.CardRenderer.builder((b) => b.standardProject('Spend 14 M€ to raise temperature 1 step.', (eb) => {
                    eb.megacredits(14).startAction.temperature(1);
                })),
            },
        });
    }
    canAct(player) {
        if (player.game.getTemperature() === constants_1.MAX_TEMPERATURE)
            return false;
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this, false, 'take this action');
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, false, false, false, false, false, false, true, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        const canUseAsteroids = player.isCorporation(CardName_1.CardName.KUIPER_COOPERATIVE);
        const canUseSpireScience = player.isCorporation(CardName_1.CardName.SPIRE);
        return player.canAfford(this.cost - super.discount(player), { asteroids: canUseAsteroids, spireScience: canUseSpireScience });
    }
    actionEssence(player) {
        player.game.increaseTemperature(player, 1);
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainHeatProductionFromTemperatureIncrease(1) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({ card: card, standardProject: StandardProjectType_1.StandardProjectType.ASTEROID, temperatureIncrease: 1, bonusMegaCredits: bonusMegaCredits });
    }
}
exports.AsteroidStandardProject = AsteroidStandardProject;
//# sourceMappingURL=AsteroidStandardProject.js.map